import { render } from "./Menu.vue?vue&type=template&id=0d587066"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=0d587066&lang=css"
script.render = render

export default script